var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMoreWhite = function SvgMoreWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083ZM10.208 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.208 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083ZM15.833 9.792a1.042 1.042 0 1 0-2.083 0 1.042 1.042 0 0 0 2.083 0Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 9.792a1.042 1.042 0 1 0-2.083 0 1.042 1.042 0 0 0 2.083 0Z",
    fill: "#fff"
  })));
};

export default SvgMoreWhite;